import publish1 from '../assets/greenpill/publish1.png';
import publish10 from '../assets/greenpill/publish10.png';
import publish100 from '../assets/greenpill/publish100.png';
import createOrg1 from '../assets/greenpill/createOrg1.png';
import createOrg10 from '../assets/greenpill/createOrg10.png';
import createOrg100 from '../assets/greenpill/createOrg100.png';
import createOrg1000 from '../assets/greenpill/createOrg1000.png';
import projectWith10Bounties from '../assets/greenpill/projectWith10Bounties.png';
import bountiesValidated10 from '../assets/greenpill/10bountiesValidated.png';
import bountiesValidated100 from '../assets/greenpill/100bountiesValidated.png';
import bountySubmissions10 from '../assets/greenpill/10bountySubmissions.png';
import bountySubmissions100 from '../assets/greenpill/100bountySubmissions.png';
import ics10 from '../assets/greenpill/10ics.png';
import ics100 from '../assets/greenpill/100ics.png';
import monetaryRewards100 from '../assets/greenpill/100dkfunds.png';
import monetaryRewards1000 from '../assets/greenpill/1000dkfunds.png';
import monetaryRewards10000 from '../assets/greenpill/10000dkfunds.png';
export const achievmentsData = [
    {
        type: 'PUBLISH_BOUNTY',
        images: [
            {
                type: 'PUBLISH_BOUNTY',
                id: 'pb1',
                key: 1,
                label: 'Creating & Publishing a Bounty to Miner',
                image: publish1,
                texts: {
                    first: 'Creating+Publishing 1 Bounty',
                    second: '20 IP',
                },
            },
            {
                type: 'PUBLISH_BOUNTY',
                id: 'pb10',
                key: 10,
                label: 'Creating & Publishing a Bounty to Miner',
                image: publish10,
                texts: {
                    first: 'Creating+Publishing 10 Bounties',
                    second: '200 IP',
                },
            },
            {
                type: 'PUBLISH_BOUNTY',
                id: 'pb100',
                key: 100,
                image: publish100,
                texts: {
                    first: 'Creating+Publishing 100 Bounties',
                    second: '2000 IP',
                },
            },
        ],
    },
    {
        type: 'GROW_ORGANISATION',
        images: [
            {
                type: 'GROW_ORGANISATION',
                id: 'go1',
                key: 1,
                image: createOrg1,
                label: 'Creating an Organization',
                texts: {
                    first: 'Creating an Organization',
                    second: '100 IP',
                },
            },
            {
                type: 'GROW_ORGANISATION',
                id: 'go10',
                key: 10,
                image: createOrg10,
                texts: {
                    first: 'Organization with 10 members',
                    second: '500 IP',
                },
            },
            {
                type: 'GROW_ORGANISATION',
                id: 'go100',
                key: 100,
                image: createOrg100,
                texts: {
                    first: 'Organization with 100 members',
                    second: '5000 IP',
                },
            },
            {
                type: 'GROW_ORGANISATION',
                id: 'go1000',
                key: 1000,
                image: createOrg1000,
                texts: {
                    first: 'Organization with 1000 members',
                    second: '50,000 IP',
                },
            },
        ],
    },
    // {
    //     type: 'REQUEST_FUNDING',
    //     images: [
    //         {
    //             type: 'REQUEST_FUNDING',
    //             id: 'rf',
    //             key: 'REQUEST_FUNDING',
    //             image: publish1,
    //         },
    //     ],
    // },
    // {
    //     type: 'CREATE_ORGANISATION',
    //     images: [
    //         {
    //             type: 'CREATE_ORGANISATION',
    //             id: 'co',
    //             key: 1,
    //             image: createOrg1,
    //             label: 'Creating an Organization',
    //             texts: {
    //                 first: 'Creating an Organization',
    //                 second: '100 IP',
    //             },
    //         },
    //     ],
    // },
    {
        type: 'PUBLISH_PROJECT_BOUNTY',
        images: [
            {
                type: 'PUBLISH_PROJECT_BOUNTY',
                id: 'ppb10',
                key: 10,
                image: projectWith10Bounties,
                texts: {
                    first: 'Project with 10 Bounties',
                    second: '100 IP',
                },
            },
        ],
    },
    // {
    //     type: 'VALIDATE_PROJECT_BOUNTY',
    //     images: [
    //         {
    //             type: 'VALIDATE_PROJECT_BOUNTY',
    //             id: 'vpb10',
    //             key: 10,
    //             image: bountiesValidated10,
    //             texts: {
    //                 first: '10 Bounties + Validated + Paid Out',
    //                 second: '1000 IP',
    //             },
    //         },
    //         {
    //             type: 'VALIDATE_PROJECT_BOUNTY',
    //             id: 'vpb100',
    //             key: 100,
    //             image: bountiesValidated100,
    //             texts: {
    //                 first: '100 Bounties + Validated + Paid Out',
    //                 second: '10,000 IP',
    //             },
    //         },
    //     ],
    // },
    {
        type: 'ISSUE_IMPACT_CERTIFICATE',
        images: [
            {
                type: 'ISSUE_IMPACT_CERTIFICATE',
                id: 'iic10',
                key: 10,
                image: ics10,
                texts: {
                    first: 'Issue 10 Impact Certificates',
                    second: '100 IP',
                },
            },
            {
                type: 'ISSUE_IMPACT_CERTIFICATE',
                id: 'iic100',
                key: 100,
                image: ics100,
                texts: {
                    first: 'Issue 100 Impact Certificates',
                    second: '1,000 IP',
                },
            },
        ],
    },
    {
        type: 'VALIDATE_BOUNTY_SUBMISSION',
        images: [
            {
                type: 'VALIDATE_BOUNTY_SUBMISSION',
                id: 'vbs10',
                key: 10,
                image: bountySubmissions10,
                texts: {
                    first: 'Validate 10 Bounty Submissions',
                    second: '100 IP',
                },
            },
            {
                type: 'VALIDATE_BOUNTY_SUBMISSION',
                id: 'vbs100',
                key: 100,
                image: bountySubmissions100,
                texts: {
                    first: 'Validate 100 Bounty Submissions',
                    second: '1,000 IP',
                },
            },
        ],
    },
    {
        type: 'ISSUE_MONETARY_REWARD',
        images: [
            {
                type: 'ISSUE_MONETARY_REWARD',
                id: 'imr100',
                key: 100,
                image: monetaryRewards100,
                texts: {
                    first: 'Deployed $100 in Impact Funds',
                    second: '',
                },
            },
            {
                type: 'ISSUE_MONETARY_REWARD',
                id: 'imr1000',
                key: 1000,
                image: monetaryRewards1000,
                texts: {
                    first: 'Deployed $1000 in Impact Funds',
                    second: '',
                },
            },
            {
                type: 'ISSUE_MONETARY_REWARD',
                id: 'imr10000',
                key: 10000,
                image: monetaryRewards10000,
                texts: {
                    first: 'Deployed $10,000 in Impact Funds',
                    second: '',
                },
            },
        ],
    },
];

export const activityData = [
    {
        type: 'PUBLISH_BOUNTY',
        images: [
            {
                type: 'PUBLISH_BOUNTY',
                id: 'pb1',
                key: 1,
                label: 'Creating & Publishing a Bounty to Miner',
                image: publish1,
                texts: {
                    first: 'Creating+Publishing 1 Bounty',
                    second: '20 IP',
                },
            },
            {
                type: 'PUBLISH_BOUNTY',
                id: 'pb10',
                key: 10,
                label: 'Creating & Publishing a Bounty to Miner',
                image: publish10,
                texts: {
                    first: 'Creating+Publishing 10 Bounties',
                    second: '200 IP',
                },
            },
            {
                type: 'PUBLISH_BOUNTY',
                id: 'pb100',
                key: 100,
                image: publish100,
                texts: {
                    first: 'Creating+Publishing 100 Bounties',
                    second: '1000 IP',
                },
            },
        ],
    },
    {
        type: 'GROW_ORGANISATION',
        images: [
            {
                type: 'GROW_ORGANISATION',
                id: 'go10',
                key: 10,
                image: createOrg10,
                label: 'Adding a Member to an Organization',
                texts: {
                    first: 'Organization with 10 members',
                    second: '500 IP',
                },
            },
            {
                type: 'GROW_ORGANISATION',
                id: 'go100',
                key: 100,
                label: 'Adding a Member to an Organization',
                image: createOrg100,
                texts: {
                    first: 'Organization with 100 members',
                    second: '5000 IP',
                },
            },
            {
                type: 'GROW_ORGANISATION',
                id: 'go1000',
                key: 1000,
                label: 'Adding a Member to an Organization',
                image: createOrg1000,
                texts: {
                    first: 'Organization with 1000 members',
                    second: '50,000 IP',
                },
            },
        ],
    },
    {
        type: 'REQUEST_FUNDING',
        images: [
            {
                type: 'REQUEST_FUNDING',
                id: 'rf',
                key: 'REQUEST_FUNDING',
                label: 'Creating and publishing a bounty to Landscapes',
                image: publish1,
            },
        ],
    },
    {
        type: 'CREATE_ORGANISATION',
        images: [
            {
                type: 'CREATE_ORGANISATION',
                id: 'co',
                key: 1,
                image: createOrg1,
                label: 'Creating an Organization',
                texts: {
                    first: 'Creating an Organization',
                    second: '100 IP',
                },
            },
        ],
    },
    {
        type: 'PUBLISH_PROJECT_BOUNTY',
        images: [
            {
                type: 'PUBLISH_PROJECT_BOUNTY',
                id: 'ppb1',
                key: 1,
                label: 'Adding a bounty in a Project',
                image: projectWith10Bounties,
                texts: {
                    first: 'Project with 10 Bounties',
                    second: '100 Ip',
                },
            },
            {
                type: 'PUBLISH_PROJECT_BOUNTY',
                id: 'ppb10',
                key: 10,
                image: projectWith10Bounties,
                texts: {
                    first: 'Project with 10 Bounties',
                    second: '10 Ip',
                },
            },
        ],
    },
    {
        type: 'VALIDATE_PROJECT_BOUNTY',
        images: [
            {
                type: 'VALIDATE_PROJECT_BOUNTY',
                id: 'vpb10',
                key: 10,
                image: bountiesValidated10,
                texts: {
                    first: '10 Bounties + Validated + Paid Out',
                    second: '1000 IP',
                },
            },
            {
                type: 'VALIDATE_PROJECT_BOUNTY',
                id: 'vpb100',
                key: 100,
                image: bountiesValidated100,
                texts: {
                    first: '100 Bounties + Validated + Paid Out',
                    second: '10,000 IP',
                },
            },
        ],
    },
    {
        type: 'ISSUE_IMPACT_CERTIFICATE',
        images: [
            {
                type: 'ISSUE_IMPACT_CERTIFICATE',
                id: 'iic1',
                key: 1,
                image: ics10,
                label: 'Issue an Impact Certificate',
                texts: {
                    first: 'Issue 10 Impact Certificates',
                    second: '1000 IP',
                },
            },
            {
                type: 'ISSUE_IMPACT_CERTIFICATE',
                id: 'iic10',
                key: 10,
                image: ics10,
                label: 'Issue an Impact Certificate',
                texts: {
                    first: 'Issue 10 Impact Certificates',
                    second: '1000 IP',
                },
            },
            {
                type: 'ISSUE_IMPACT_CERTIFICATE',
                id: 'iic100',
                key: 100,
                label: 'Issue an Impact Certificate',
                image: ics100,
                texts: {
                    first: 'Issue 100 Impact Certificates',
                    second: '10,000 IP',
                },
            },
        ],
    },
    {
        type: 'VALIDATE_BOUNTY_SUBMISSION',
        images: [
            {
                type: 'VALIDATE_BOUNTY_SUBMISSION',
                id: 'vbs1',
                key: 1,
                label: 'Validating a bounty submission',
                image: bountySubmissions10,
                texts: {
                    first: 'Validate 10 Bounty Submissions',
                    second: '1000 IP',
                },
            },
            {
                type: 'VALIDATE_BOUNTY_SUBMISSION',
                id: 'vbs10',
                key: 10,
                label: 'Validating a bounty submission',
                image: bountySubmissions10,
                texts: {
                    first: 'Validate 10 Bounty Submissions',
                    second: '1000 IP',
                },
            },
            {
                type: 'VALIDATE_BOUNTY_SUBMISSION',
                id: 'vbs100',
                key: 100,
                label: 'Validating a bounty submission',
                image: bountySubmissions100,
                texts: {
                    first: 'Validate 100 Bounty Submissions',
                    second: '10,000 IP',
                },
            },
        ],
    },
    {
        type: 'ISSUE_MONETARY_REWARD',
        images: [
            {
                type: 'ISSUE_MONETARY_REWARD',
                id: 'imr100',
                key: 100,
                label: 'Processing payouts',
                image: monetaryRewards100,
                texts: {
                    first: 'Deployed $100 in Impact Funds',
                    second: 'IP',
                },
            },
            {
                type: 'ISSUE_MONETARY_REWARD',
                id: 'imr1000',
                key: 1000,
                label: 'Processing payouts',
                image: monetaryRewards1000,
                texts: {
                    first: 'Deployed $1000 in Impact Funds',
                    second: 'IP',
                },
            },
            {
                type: 'ISSUE_MONETARY_REWARD',
                id: 'imr10000',
                key: 10000,
                label: 'Processing payouts',
                image: monetaryRewards10000,
                texts: {
                    first: 'Deployed $10,000 in Impact Funds',
                    second: 'IP',
                },
            },
        ],
    },
];

// const ACTIVITY_IMPACT_POINTS = {
//     PUBLISH_BOUNTY: { impactPoints: 20, achievementMilestones: [1, 10, 100] },
//     REQUEST_FUNDING: { impactPoints: 10, achievementMilestones: [] },
//     CREATE_ORGANISATION: { impactPoints: 100, achievementMilestones: [1] },
//     PUBLISH_PROJECT_BOUNTY: { impactPoints: 10, achievementMilestones: [10] },
//     VALIDATE_PROJECT_BOUNTY: { impactPoints: 0, achievementMilestones: [10, 100] },
//     ISSUE_IMPACT_CERTIFICATE: { impactPoints: 10, achievementMilestones: [10, 100] },
//     VALIDATE_BOUNTY_SUBMISSION: { impactPoints: 10, achievementMilestones: [1, 10, 100] },
//     GROW_ORGANISATION: { impactPoints: 50, achievementMilestones: [10, 100, 1000] },
//     ISSUE_MONETARY_REWARD: { achievementMilestones: [100, 1000, 10000] },
// };

// [
//     'PUBLISH_BOUNTY',
//     'PUBLISH_PROJECT_BOUNTY',
//     'VALIDATE_PROJECT_BOUNTY',
//     'ISSUE_IMPACT_CERTIFICATE',
//     'VALIDATE_BOUNTY_SUBMISSION',
//     'ISSUE_MONETARY_REWARD',
//     'REQUEST_FUNDING',
//     'CREATE_ORGANISATION',
//     'GROW_ORGANISATION',
// ];

export const allAchievementImages = achievmentsData.flatMap((entry) => entry.images);
export const allActivityImages = activityData.flatMap((entry) => entry.images);

// validate bounty submission 1 image
